import {
  DEFAULT_OBLIGATION_CATEGORY,
  Obligation,
  ObligationCategory,
} from '../models/obligation.model';

/**
 * Normalizes obligations data input
 * - Accepts: (string | Obligation)[]
 * - Returns: Obligation[] (with ID preserved for existing obligations)
 * Usage: use everywhere obligations are loaded/rendered/exported
 */
export function normalizeObligations(input?: (string | Obligation)[] | null): Obligation[] {
  if (!Array.isArray(input)) return [];
  return input.map(item => {
    if (typeof item === 'string') {
      return { text: item, links: [], steps: undefined };
    } else if (
      typeof item === 'object' &&
      item !== null &&
      typeof (item as Obligation).text === 'string'
    ) {
      // Always ensure links/steps fields are present, preserve ID if it exists
      return {
        ...(item.id ? { id: item.id } : {}), // Include ID if it exists
        text: item.text,
        links: Array.isArray(item.links) ? item.links : [],
        steps: typeof item.steps === 'string' ? item.steps : undefined,
        triggering_finding:
          typeof item.triggering_finding === 'string' ? item.triggering_finding : undefined,
        category: item.category ?? null,
      };
    } else {
      return { text: String(item), links: [], steps: undefined };
    }
  });
}

/**
 * Resolves an obligation's grouping bucket, mapping null/absent (legacy
 * records) to `GENERAL`. Single chokepoint so every surface groups the
 * same way. See [[Obligation.category]].
 */
export function resolveObligationCategory(obligation: Obligation): ObligationCategory {
  return obligation.category ?? DEFAULT_OBLIGATION_CATEGORY;
}
